"use client";
import {
  useMenuStore
} from "../__chunks/MS4VD4RJ.js";
import {
  MenuContextProvider
} from "../__chunks/LG4RFBHV.js";
import "../__chunks/WSQNIDGC.js";
import "../__chunks/DWZ7E5TJ.js";
import "../__chunks/UVQLZ7T5.js";
import "../__chunks/TCAGH6BH.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/CTQR3VDU.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import "../__chunks/XMDAT5SM.js";
import "../__chunks/CBC47ZYL.js";
import "../__chunks/QYS5FHDY.js";
import "../__chunks/KGK2TTFO.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-provider.tsx
import { jsx } from "react/jsx-runtime";
function MenuProvider(props = {}) {
  const store = useMenuStore(props);
  return /* @__PURE__ */ jsx(MenuContextProvider, { value: store, children: props.children });
}
export {
  MenuProvider
};
